const whitebitWithdrawStatusCodes = {
  1: {
    code: 1,
    name: {
      en: "Pending",
      ru: "Ожидание"
    }
  },
  2: {
    code: 2,
    name: {
      en: "Pending",
      ru: "Ожидание"
    }
  },
  6: {
    code: 6,
    name: {
      en: "Pending",
      ru: "Ожидание"
    }
  },
  10: {
    code: 10,
    name: {
      en: "Pending",
      ru: "Ожидание"
    }
  },
  11: {
    code: 11,
    name: {
      en: "Pending",
      ru: "Ожидание"
    }
  },
  12: {
    code: 12,
    name: {
      en: "Pending",
      ru: "Ожидание"
    }
  },
  13: {
    code: 13,
    name: {
      en: "Pending",
      ru: "Ожидание"
    }
  },
  14: {
    code: 14,
    name: {
      en: "Pending",
      ru: "Ожидание"
    }
  },
  15: {
    code: 15,
    name: {
      en: "Pending",
      ru: "Ожидание"
    }
  },
  16: {
    code: 16,
    name: {
      en: "Pending",
      ru: "Ожидание"
    }
  },
  17: {
    code: 17,
    name: {
      en: "Pending",
      ru: "Ожидание"
    }
  },
  3: {
    code: 3,
    name: {
      en: "Successful",
      ru: "Успешно"
    }
  },
  7: {
    code: 7,
    name: {
      en: "Successful",
      ru: "Успешно"
    }
  },
  4: {
    code: 4,
    name: {
      en: "Canceled",
      ru: "Отменено"
    }
  },
  5: {
    code: 5,
    name: {
      en: "Unconfirmed by user",
      ru: "Не было подтверждено пользователем"
    }
  },
  18: {
    code: 18,
    name: {
      en: "Partially successful",
      ru: "Частично успешно"
    }
  }
};

const getWhitebitWithdrawStatus = statusCode => {
  return whitebitWithdrawStatusCodes[statusCode] || null;
};

const getHashCheckUrl = wbWithdrawStatus => {
  const urlTemplates = {
    BTC: {
      getUrl: hash =>
        `https://www.blockchain.com/explorer/transactions/btc/${hash}`
    },
    USDT: {
      getUrl: hash => `https://tronscan.org/#/transaction/${hash}`
    },
    XMR: {
      getUrl: hash => `https://localmonero.co/blocks/search/${hash}`
    }
  };
  const urlTemplate = urlTemplates[wbWithdrawStatus.ticker];
  return urlTemplate
    ? urlTemplate.getUrl(wbWithdrawStatus.transactionHash)
    : "#";
};

export {
  whitebitWithdrawStatusCodes,
  getWhitebitWithdrawStatus,
  getHashCheckUrl
};



// WEBPACK FOOTER //
// ./src/components/ui/helpers.js